import React from 'react';
import { Button, CardContent, Card } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { isNil } from 'lodash';

import Tooltip from '../Tooltip';
import LocationDropDown from './LocationDropDown';
import Content from '../../pages/tools/content/index';
import { isMobile } from '../../../lib/getDeviceSize';
import { buttonStyles } from '../../../styles/base';

interface Props {
  cities: any[];
  classes: any;
  disabled?: boolean;
  hideCityField?: boolean;
  locations: any[];
  selectedCity: string | undefined;
  selectedLocation: string | undefined;
  onSubmit: Function;
  setCity: Function;
  setLocation: Function;
  toolsHeadline: string;
  toolTipText?: string;
}

const styles = {
  addressCardTitle: {
    display: 'flex',
    marginBottom: 35,
  },
  card: {
    alignItems: 'center',
    display: 'flex',
    // height: isMobile() ? 316 : 294,
    justifyContent: 'center',
    margin: '0 auto',
    paddingLeft: isMobile() ? 9 : 0,
    paddingRight: isMobile() ? 9 : 0,
    width: isMobile() ? 350 : 640,
    zIndex: 1,
  },
  compsAddressSearchField: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: isMobile() ? '100%' : 400,
    flexDirection: 'column',
  },
};

export class LocationFormCard extends React.Component<Props> {
  render() {
    const {
      cities,
      classes,
      disabled,
      hideCityField,
      locations,
      onSubmit,
      selectedCity,
      selectedLocation,
      setCity,
      setLocation,
      toolsHeadline,
      toolTipText,
    } = this.props;

    return (
      <Content>
        <Card className={classes.card}>
          <CardContent>
            <div className={classes.addressCardTitle}>
              <h3>{toolsHeadline}</h3>
              {toolTipText && <Tooltip text={toolTipText} />}
            </div>

            <LocationDropDown
              cities={cities}
              disabled={disabled}
              hideCityField={hideCityField}
              locations={locations}
              selectedCity={selectedCity}
              selectedLocation={selectedLocation}
              setCity={setCity}
              setLocation={setLocation}
              wrapperClasses={classes.compsAddressSearchField}
            >
              {this.props.children}
            </LocationDropDown>
            <Button
              className={`${classes.buttonMediumGreen}`}
              style={{
                marginTop: 10,
                maxWidth: '100%',
                width: 275,
              }}
              onClick={() => onSubmit(selectedLocation)}
              variant="contained"
              disabled={isNil(selectedLocation)}
            >
              SUBMIT
            </Button>
          </CardContent>
        </Card>
      </Content>
    );
  }
}

export default withStyles({ ...buttonStyles, ...styles })(LocationFormCard);
